module.exports = __webpack_public_path__ + "static/media/no-data-class-icon.cfde0f20.svg";